import './Home.svelte.css';
/* src/pages/Home.svelte generated by Svelte v3.57.0 */
import {
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import Header from "../components/Header.svelte.js";
import ExpressionParser from "../components/ExpressionParser.svelte.js";
import Workspace from "../components/Workspace.svelte.js";
import Navigation from "../components/Navigation.svelte.js";
import ActionButtons from "../components/ActionButtons.svelte.js";
import Chart from "../components/Chart.svelte.js";

function create_fragment(ctx) {
	let main;
	let header1;
	let header0;
	let t0;
	let nav;
	let expressionparser;
	let t1;
	let div0;
	let actionbuttons;
	let t2;
	let div1;
	let navigation;
	let t3;
	let div2;
	let workspace;
	let t4;
	let div3;
	let chart;
	let current;
	header0 = new Header({});
	expressionparser = new ExpressionParser({ props: { clearOnFinish: true } });
	actionbuttons = new ActionButtons({});
	navigation = new Navigation({});
	workspace = new Workspace({});
	chart = new Chart({});

	return {
		c() {
			main = element("main");
			header1 = element("header");
			create_component(header0.$$.fragment);
			t0 = space();
			nav = element("nav");
			create_component(expressionparser.$$.fragment);
			t1 = space();
			div0 = element("div");
			create_component(actionbuttons.$$.fragment);
			t2 = space();
			div1 = element("div");
			create_component(navigation.$$.fragment);
			t3 = space();
			div2 = element("div");
			create_component(workspace.$$.fragment);
			t4 = space();
			div3 = element("div");
			create_component(chart.$$.fragment);
			attr(header1, "class", "header svelte-11m15c6");
			attr(nav, "class", "parser svelte-11m15c6");
			attr(div0, "class", "action-buttons svelte-11m15c6");
			attr(div1, "class", "navigation svelte-11m15c6");
			attr(div2, "class", "workspace svelte-11m15c6");
			attr(div3, "class", "chart svelte-11m15c6");
			attr(main, "class", "svelte-11m15c6");
		},
		m(target, anchor) {
			insert(target, main, anchor);
			append(main, header1);
			mount_component(header0, header1, null);
			append(main, t0);
			append(main, nav);
			mount_component(expressionparser, nav, null);
			append(main, t1);
			append(main, div0);
			mount_component(actionbuttons, div0, null);
			append(main, t2);
			append(main, div1);
			mount_component(navigation, div1, null);
			append(main, t3);
			append(main, div2);
			mount_component(workspace, div2, null);
			append(main, t4);
			append(main, div3);
			mount_component(chart, div3, null);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(header0.$$.fragment, local);
			transition_in(expressionparser.$$.fragment, local);
			transition_in(actionbuttons.$$.fragment, local);
			transition_in(navigation.$$.fragment, local);
			transition_in(workspace.$$.fragment, local);
			transition_in(chart.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(header0.$$.fragment, local);
			transition_out(expressionparser.$$.fragment, local);
			transition_out(actionbuttons.$$.fragment, local);
			transition_out(navigation.$$.fragment, local);
			transition_out(workspace.$$.fragment, local);
			transition_out(chart.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(main);
			destroy_component(header0);
			destroy_component(expressionparser);
			destroy_component(actionbuttons);
			destroy_component(navigation);
			destroy_component(workspace);
			destroy_component(chart);
		}
	};
}

class Home extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Home;